module.exports = __webpack_public_path__ + "static/media/logo_thonburi_full.216d548a.svg";